import { Box, Checkbox, type CheckboxProps, Typography } from "@mui/material";
import { type ReactNode, useRef } from "react";
import type { FieldError } from "react-hook-form";

import { BlErrorMessage } from "Shared/Inputs/ErrorMessage";

type BlCheckboxInputProps = CheckboxProps & {
  label?: string | ReactNode;
  isLabelFirst?: boolean;
  labelEndAdornment?: ReactNode;
  fieldError?: FieldError;
};

export const BlCheckboxInput = ({
  label,
  isLabelFirst,
  labelEndAdornment,
  fieldError,
  disabled,
  ...rest
}: BlCheckboxInputProps): React.ReactNode => {
  const checkboxRef = useRef<HTMLInputElement>(null);

  const LabelElement = (
    <label htmlFor={rest.name} onClick={() => checkboxRef.current?.click()}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          mb: 0,
          color: disabled ? "text.disabled" : "text.primary",
        }}
      >
        <Typography variant="body2">{label}</Typography>
        {labelEndAdornment}
      </Box>
    </label>
  );

  return (
    <Box>
      <Box
        className="checkbox"
        sx={{
          display: "flex",
          userSelect: "none",
          alignItems: "center",
          "& > label": {
            display: "flex",
            cursor: "pointer",
            pl: 1,
            width: "100%",
          },
        }}
      >
        {isLabelFirst && label && LabelElement}
        <Checkbox
          id={rest.name}
          disabled={disabled}
          slotProps={{ input: { ref: checkboxRef } }}
          {...rest}
          value={
            rest.value === undefined || rest.value === null ? "" : rest.value
          }
        />
        {!isLabelFirst && label && LabelElement}
      </Box>
      <BlErrorMessage error={fieldError} />
    </Box>
  );
};
